import SortIcon from './SortIcon/SortIcon'
import { HeaderCell, SortButton, SortIconSlot } from '../styled-components'

interface ColumnHeaderProps {
  label: string
  direction: 'ASC' | 'DESC' | null
  onSort: () => void
}

const ARIA_SORT = { ASC: 'ascending', DESC: 'descending' } as const

const ColumnHeader = ({ label, direction, onSort }: ColumnHeaderProps) => (
  <HeaderCell role='columnheader' aria-sort={direction ? ARIA_SORT[direction] : 'none'}>
    <SortButton type='button' $active={direction !== null} onClick={onSort}>
      {label}
      <SortIconSlot $active={direction !== null}>
        <SortIcon direction={direction} />
      </SortIconSlot>
    </SortButton>
  </HeaderCell>
)

export default ColumnHeader
